/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { ERROR_DIALOG_TITLE, SimpleSuccessErrorDialogComponent } from "app/components/simple-success-error-dialog-box/simple-success-error-dialog-box.component";
import { ObjectInstance } from "../../../models/object-instance";
import { Rule } from "../../../models/rule";
import { RuleCondition, Operator } from "../../../models/rule-condition";
import { ObjectService } from "../../../services/object.service";
import {Component, OnInit, Input, ViewChild} from "@angular/core";

@Component({
  selector: 'app-object-parameter-editor',
  templateUrl: './object-parameter-editor.component.html'
})
export class ObjectParameterEditorComponent implements OnInit {
  
  /** Reference to the SimpleSuccessErrorDialog used to display error */
  @ViewChild('successErrorDialog') 
  simpleSuccessErrorDialogComponent: SimpleSuccessErrorDialogComponent;

  @Input()
  mRule: Rule;
  
  @Input()
  mRuleCondition: RuleCondition;
  
  @Input()
  mUniqueIndex: number;
  
  mSelectedObjectInstance: ObjectInstance;
  
  mAvailableOperators: Operator[] = [];
  
  mShowBody = false;
  
  
  constructor(
    private mObjectService: ObjectService
  ) {}
  
  ngOnInit(): void {
    //Refresh the selected Object Instance to retrieve it if one is already selected (editing an existing Condition)
    this.refreshSelectedObjectInstance();
    
    //Get the Operators that are available to be used
    this.mAvailableOperators = [ Operator.EQUAL, Operator.NOT_EQUAL ];
    this.mShowBody = this.mRuleCondition != null && this.mRuleCondition.id != null ? false : true;
  }
  
  private refreshSelectedObjectInstance(): void {
    if (this.mRuleCondition != null && this.mRuleCondition.value != null && this.mRuleCondition.value.length != 0) {
      const id = Number.parseInt(this.mRuleCondition.value);
      this.mObjectService
        .getObjectInstanceForId(id)
        .then(
          objectInstance => {
            this.mSelectedObjectInstance = objectInstance;
          },
          error => this.handleError(error)
        );
    }
  }
  
  getValueLabel(): string {
    return this.mRuleCondition.value;
  }
  
  getParameterLabel(): string {
    if (this.mRule != null && this.mRule.event != null && this.mRule.event.properties != null) {
        const property = this.mRule.event.properties.find(property => property.property == this.mRuleCondition.property);
        
        return property != null ? property.name : "?";
    }
    else {
        return "?";
    }
  }
  
  getOperatorLabel(operator: Operator): string {
    if (operator != null) {
        switch (operator) {
            case Operator.EQUAL:
                return "is";
            case Operator.NOT_EQUAL:
                return "is not";
        }
    }
  }

  onRemove(condition: RuleCondition): void {
    const index = this.mRule.conditions.indexOf(condition);
    
    if (index > -1) {
        this.mRule.conditions.splice(index, 1);
    }
  }
    
  handleError(error: any): void {
    console.error("handleError() - Error: " + error);
    if (error != null) {
      const response: Response = error;
      this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, response.text().toString());
    }
  }

}
